import React, { useEffect, useState } from "react";
import { TextField, MenuItem, Select, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../axiosInstance";
import Swal from 'sweetalert2';


const CreateMultiPriceList = () => {

  const [productlist, setproductlist] = useState([])

  const providerId = sessionStorage.getItem('providerId');
  const userid = sessionStorage.getItem('userid');



  const { did, cid } = useParams();

  const getProductList = async () => {
    try {

      // mulitiple url
      // let url
      // if(providerId !== '0'){
      //   url =`/userproduct?DISID=${userid}`
      // }else{
      //   url =`/products?page=1`
      // }
      let url = providerId !== '0' ? `/userproduct?DISID=${userid}` : `/products?page=1`
      const response = await api.get(url);
      console.log("response", response.data);

      // Ensure it's always an array of objects with { id, name }
      setproductlist(response?.data?.data)

    } catch (error) {
      console.error('Error fetching product list:', error);
      setproductlist([]); // Fallback to an empty array on error
    }
  };


  console.log("productid and value", productlist);




  useEffect(() => {
    getProductList()
  }, [])


  const distributors = [
    { id: 1, name: "Distributor A" },
    { id: 2, name: "Distributor B" },
  ];
  const products = [
    ...productlist
  ];

  const onSubmit = (data) => {
    console.log("Sending data to API:", data);
  };

  const [formData, setFormData] = useState({
    product_id: "",
    user_id: did,
    user_parent_id: providerId !== '0' ? userid : 1,
    price: "",
    effected_from: "",
  });

  const [dataArray, setDataArray] = useState([]);
  const [editIndex, setEditIndex] = useState(null);


  const navigate = useNavigate();

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleAddOrUpdate = () => {
    if (formData.product_id && formData.price && formData.effected_from) {
      if (editIndex !== null) {
        const updatedData = [...dataArray];
        updatedData[editIndex] = { id: editIndex + 1, ...formData };
        setDataArray(updatedData);
        setEditIndex(null);
      } else {
        setDataArray((prev) => [
          ...prev,
          { id: prev.length + 1, ...formData },
        ]);
      }
      setFormData({ product_id: "", price: "", effected_from: "" });
    }
  };

  const handleEdit = (index) => {
    setFormData(dataArray[index]);
    setEditIndex(index);
  };

  const handleDelete = (id) => {
    setDataArray(dataArray.filter((row) => row.id !== id));
  };

  const handleSubmit = async () => {
    try {
      const requestData = dataArray.map(({ id, ...rest }) => ({
        ...rest,
        price: Number(rest.price),
      }));
      const response = await api.post(`/userproduct`, ...requestData);
      console.log("API Response:", response.data);
      Swal.fire({
        icon: "success",
        title: "success",
        text: response.data?.message,
      });
      navigate(-1)
    } catch (error) {
      // console.error("Error submitting data:", error?.response?.data?.message);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message,
      });
    }
  };

  const columns = [
    // { field: "distributor", headerName: "Distributor", flex: 1 },
    { field: "product_id", headerName: "Product", flex: 1 },
    { field: "price", headerName: "Price", flex: 1 },
    { field: "effected_from", headerName: "Date", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      renderCell: (params) => (
        <>
          <Button size="small" onClick={() => handleEdit(params.row.id - 1)}>
            Edit
          </Button>
          <Button size="small" color="error" onClick={() => handleDelete(params.row.id)}>
            Delete
          </Button>
        </>
      ),
      flex: 1,
    },
  ];


  const selectedProduct = products.find(p => p.id === formData.product_id);

  useEffect(() => {
    if (products.length > 0 && !formData.product_id) {
      setFormData((prev) => ({
        ...prev,
        product_id: products[0].id,  // set first product
      }));
    }
  }, [products]);

  return (
    <div style={{ width: "100%", margin: "auto" }}>
      {/* <div>
        <button className='btn btn-primary m-1' onClick={() => navigate(`/assignreseller`)}>Back</button>
      </div> */}
      <div className="d-flex gap-4">
        {/* <Select
          value={formData.distributor}
          onChange={(e) => handleChange("distributor", e.target.value)}
          displayEmpty
          fullWidth
        >
          <MenuItem value="" disabled>Select Distributor</MenuItem>
          {distributors.map((dist) => (
            <MenuItem key={dist.id} value={dist.name}>{dist.name}</MenuItem>
          ))}
        </Select> */}

        <Select
          value={formData.product_id || ""}
          onChange={(e) => handleChange("product_id", e.target.value)}
          displayEmpty
          fullWidth
        >
          <MenuItem value="" disabled>Select Product</MenuItem>
          {products.map((prod) => (
            <MenuItem key={prod.id} value={prod.id}>{prod.name}</MenuItem>
          ))}
        </Select>

        <TextField
          type="number"
          value={formData.price}
          onChange={(e) => handleChange("price", e.target.value)}
          fullWidth
          placeholder={`Minimum value : ${selectedProduct?.price || 0}`}
          inputProps={{
            min: selectedProduct?.price || 0
          }}
          helperText={
            formData.price && Number(formData.price) < (selectedProduct?.price || 0)
              ? `Price must be at least ${selectedProduct?.price}`
              : ""
          }
        />

        {/* Date Field */}
        <TextField
          type="date"
          value={formData.effected_from}
          onChange={(e) => handleChange("effected_from", e.target.value)}
          fullWidth
          InputLabelProps={{ shrink: true }}
        />

        <Button variant="contained" onClick={handleAddOrUpdate} fullWidth>
          {editIndex !== null ? "Update" : "Add"}
        </Button>
      </div>

      <div style={{ height: 300, width: "100%", marginTop: 20 }}>
        <DataGrid
          rows={dataArray}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
        />
      </div>

      <div className="d-flex gap-4 mt-4">
        <Button variant="contained" color="secondary" onClick={() => setDataArray([])} fullWidth>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={handleSubmit} fullWidth>
          Submit
        </Button>
      </div>
    </div>
  );
};

export default CreateMultiPriceList;
